export default __webpack_public_path__ + "static/media/lamp.4f82b1c4.jpg";